import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnChanges,
} from "@angular/core";
import { NgxSmartModalService } from "ngx-smart-modal";
import { GeneralLedgerDetail } from "../../Model/gl-detail";
import * as moment from "moment";
import { GeneralLedgerDetailService } from "../../Services/general-ledger-detail.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "general-ledger-detail-list",
  templateUrl: "./general-ledger-detail-list.component.html",
  styleUrls: ["./general-ledger-detail-list.component.css"],
})
export class GeneralLedgerDetailListComponent implements OnInit, OnChanges {
  @Input()
  items: GeneralLedgerDetail[];

  @Output()
  gridSelection: EventEmitter<any> = new EventEmitter();

  @Output()
  export: EventEmitter<any> = new EventEmitter();

  public columnDefs = [];
  public rowData = [];
  private gridApi;
  private gridColumnApi;
  private gridOptions;
  private defaultColDef;
  private rowSelection;
  private editable: boolean;

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    private glDetailService: GeneralLedgerDetailService,
    private toastr: ToastrService
  ) {
    this.defaultColDef = { sortable: true, filter: true };
    this.rowSelection = "single";
    this.createGridColumnDefs();
  }

  createGridColumnDefs() {
    this.columnDefs = [
      { headerName: "ID", field: "id", hide: true },
      { headerName: "changeID", field: "changeID", hide: true },
      { headerName: "lastUpdated", field: "lastUpdated", hide: true },
      {
        headerName: "Bus Unit",
        field: "businessUnit",
        filter: "agTextColumnFilter",
        width: 100,
        pinned: "left",
      },
      {
        headerName: "Account",
        field: "accountObject",
        filter: "agTextColumnFilter",
        width: 100,
        pinned: "left",
      },
      {
        headerName: "Facility",
        field: "accountSubsidiary",
        filter: "agTextColumnFilter",
        width: 100,
        pinned: "left",
      },
      {
        headerName: "Description",
        field: "accountDescription",
        filter: "agTextColumnFilter",
        width: 250,
        pinned: "left",
      },
      {
        headerName: "Debit",
        field: "debitAmount",
        type: "numericColumn",
        filter: "agTextColumnFilter",
        width: 125,
        cellRenderer: this.CurrencyCellRenderer,
      },
      {
        headerName: "Credit",
        field: "creditAmount",
        type: "numericColumn",
        filter: "agTextColumnFilter",
        width: 125,
        cellRenderer: this.CurrencyCellRenderer,
      },
      {
        headerName: "Source",
        field: "documentType",
        filter: "agTextColumnFilter",
        width: 125,
      },
      {
        headerName: "Document#",
        field: "documentNumber",
        filter: "agTextColumnFilter",
        type: "numericColumn",
        width: 125,
      },
      {
        headerName: "G/L Date",
        field: "glDate",
        filter: "agDateColumnFilter",
        width: 150,
        filterParams: {
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            var dateAsString = cellValue;
            if (dateAsString == null) return -1;

            // In the example application, dates are stored as dd/mm/yyyy
            // We create a Date object for comparison against the filter date
            var dateParts = dateAsString.split("-");
            var cellDate = new Date(
              Number(dateParts[0]),
              Number(dateParts[1]) - 1,
              Number(dateParts[2])
            );
            if (filterLocalDateAtMidnight.getTime() == cellDate.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          },
          browserDatePicker: true,
        },
        valueFormatter: (params) => {
          return params.value != "0001-01-01"
            ? moment(params.value).format("MM/DD/YYYY")
            : "";
        },
      },
      {
        headerName: "Fiscal Year",
        field: "fiscalYear",
        type: "numericColumn",
        filter: "agTextColumnFilter",
        width: 125,
        editable: this.editable,
      },
      {
        headerName: "Period",
        field: "periodNumber",
        type: "numericColumn",
        filter: "agTextColumnFilter",
        width: 125,
        editable: this.editable,
      },
      {
        headerName: "Explanation",
        field: "explanation",
        filter: "agTextColumnFilter",
        width: 250,
        editable: this.editable,
      },
      {
        headerName: "Reference",
        field: "reference",
        filter: "agTextColumnFilter",
        width: 250,
        editable: this.editable,
      },
      {
        headerName: "Invoice",
        field: "invoiceNumber",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "PO#",
        field: "purchaseOrderId",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Posted",
        field: "postedCode",
        filter: "agTextColumnFilter",
        width: 125,
      },
    ];
  }

  onExportClicked() {
    let params = {
      fileName: "GLDetail",
      allColumns: true,
    };
    this.gridApi.exportDataAsExcel(params);
  }

  onCellValueChanged(params) {
    let isCredit = false;

    if (Number(params.data.amount) < 0) {
      isCredit = true;
    } else {
      isCredit = false;
    }

    // Delete record if zero out amount
    if (
      (isCredit &&
        (params.data.creditAmount == "0" || params.data.creditAmount == "")) ||
      (!isCredit &&
        (params.data.debitAmount == "0" || params.data.debitAmount == ""))
    ) {
      this.glDetailService.delete(params.data.id).subscribe((response) => {});
    } else {
      let amount = 0;

      if (isCredit) amount = params.data.creditAmount * -1;
      else amount = params.data.debitAmount;

      let formData = {
        amount: amount,
        glDate: params.data.glDate,
        fiscalYear: params.data.fiscalYear,
        period: params.data.periodNumber,
        explanation: params.data.explanation,
        reference: params.data.reference,
        id: params.data.id,
      };
      this.glDetailService.updateFromCustomerLedger(formData).subscribe(
        (response) => {
          if (response["success"] == "true")
            this.toastr.success("Record updated", "Success");
        },
        (error) => {
          this.toastr.error("Unexpected error occurred", "Error");
        }
      );
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //params.api.sizeColumnsToFit();
    this.export.emit(this.gridApi);
  }

  onSelectionChanged(event) {
    // Emit changes up to parent
    // Pass object { rowSelected: xxx, gridEvent: xxx }
    this.gridSelection.emit({
      rowSelected: this.gridApi.getSelectedRows(),
      gridEvent: event,
    });
  }

  ngOnInit() {}

  ngOnChanges() {
    if (this.items) {
      if (this.items.length > 0) {
        if (this.items[0].postedCode == "Y") this.editable = false;
        else this.editable = true;
      } else this.editable = false;
    } else {
      this.editable = false;
    }
  }

  private CurrencyCellRenderer(params: any) {
    var usdFormate = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    });
    return params.value == null ? "" : usdFormate.format(params.value);
  }
}
